export default {
  transactions: 'Transactions',
  'transactions.allTransactions': 'All Transactions',
  'transactions.payments': 'Payments',
  'transactions.refunds': 'Refunds',
};
